"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeUIButton = exports.RangeUIWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Button_1 = require("../Button");
const Flex_1 = require("../Flex");
exports.RangeUIWrapper = (0, styled_1.default)(Flex_1.Flex)(() => ({
    border: constants_1.theme.border.style.thin,
    borderRadius: constants_1.theme.border.radius.normal,
    overflow: 'hidden',
    boxShadow: constants_1.theme.boxShadow.normal,
}));
exports.RangeUIButton = (0, styled_1.default)(Button_1.Button)({
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
});
